<template>
  <div class="useragreement-view">
    <h1 class="agreement-title">用户协议</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <h2>1. 导言</h2>
        <p>1.1 欢迎您使用<u>易趣软件网站</u>产品及相关服务！</p>
        <p><u>易趣软件网站</u>产品及相关服务（下称“本产品及相关服务”），系指<u>易软信息科技（惠州）有限公司</u>及其关联方（以下简称“我方”）合法拥有并运营的<u>在线网站及相关服务</u>。《用户协议》（以下称“本协议”）是您与我方就您使用本产品及相关服务所订立的协议。</p>
        <p>1.2 为了更好地为您提供服务，请您在开始使用本产品及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以<b><u>加粗、下划线</u></b>等形式提示您注意，您应重点阅读。</p>
        <p>1.3 如您未成年，您以及您的法定监护人都应该仔细阅读、充分理解并同意本协议，您应该确保在全部接受本协议内容并征得法定监护人的同意后使用本产品及相关服务。</p>
        <p>1.4 如果您不同意本协议中的任何条款，请您不要使用本产品及相关服务，您也可以随时选择停止使用本产品及相关服务。如您自主选择同意或使用本产品及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与本产品及相关服务有关的协议和规则（包括但不限于《隐私政策》）的约束。</p>
        <p><b>1.5 我方有权依本产品及相关服务运营的需要单方决定，安排或指定关联方、控制公司、继承公司或公司认可的第三方公司继续运营本产品及相关服务。并且，就本协议项下涉及的某些服务，可能会由公司的关联方、控制公司、继承公司或公司认可的第三方公司向您提供。您知晓并同意接受相关服务内容，即视为接受相关权利义务关系亦受本协议约束。</b></p>
        <p>1.6 如对本协议内容有任何疑问、意见或建议，请您及时通过我方提供的官方联系方式同我方取得联系。</p>
        <h2>2. 本产品及相关服务</h2>
        <h3>2.1 您可以通过我方官方授权的渠道获取本产品并接受相关服务。若您并非通过我方官方授权的渠道获取本产品及相关服务的，我方无法保证非官方版本能够正常使用，您因此遭受的损失与我方无关。</h3>
        <p>2.2 我方可能为不同的终端设备开发不同的版本，您应当根据实际设备状况获取、下载、安装合适的版本。</p>
        <p>2.3 您可根据需要自行使用本产品及相关服务或更新版本，如您不再需要使用本产品及相关服务，您也可自行卸载本软件。</p>
        <p><b><u>2.4 为更好的提升用户体验及服务，我方将不定期提供本产品及相关服务的更新或改变（包括但不限于针对本产品即相关服务进行修改、升级、功能强化、开发新服务、替换现有内容等）。为保证本产品及相关服务安全、提升用户服务，本产品及相关服务部分或全部更新后，我方将在可行情况下以适当方式（包括但不限于系统提示、公告等）提示您；您在更新或改变发生后，使用本产品及相关服务的，视为您完全接受了我方做出的调整。我方保留因业务发展需要，单方面对部分功能效果进行改变或进行限制的权利，您应承担与此相关的风险。</u></b></p>
        <p><b><u>2.5 除非得到我方事先书面授权，您不得以任何形式对本产品及相关服务进行包括但不限于改编、复制、传播、镜像、交易以及将本软件作为为其他人提供服务的工具等未经授权的访问或使用。</u></b></p>
        <p>2.6 您理解，您使用本产品及相关服务需自行准备与本产品及相关服务有关的终端设备（如电脑、手机等装置），一旦您在您的终端设备中访问相关网站、服务，即视为您使用本产品及相关服务。为充分实现的全部功能，您可能需要将您的终端设备联网，您应自行承担所需要的费用（如流量费、上网费等）。</p>
        <p><b><u>2.7 我方许可您一项个人的、可撤销的、不可转让的、非独占地和非商业的合法使用本产品及相关服务的权利，您不享有本产品的所有权。请您尤其注意，我方基于本协议对您的授权仅为授权您个人以非商业的目的对于本产品及相关服务进行使用，任何超出个人使用目的的使用行为都必须另行获得我方具体的、单独的书面授权，协议未明示授权的其他一切权利仍由我方保留，您在行使该等权利前须另行获得我方的书面许可，同时我方如未行使前述任何权利，并不构成对该权利的放弃。</u></b></p>
        <p><b><u>授权的有效性依赖于如下条件：</u></b></p>
        <p><b>（1）<u>本产品的使用未违反本协议及本产品上的各项规则。</u></b></p>
        <p><b>（2）<u>您取得了必要的授权和资格以使用本产品及相关服务。</u></b></p>
        <p><b>（3）<u>本协议被无保留和修改地全部接受，且没有被违反。</u></b></p>
        <p><b>（4）<u>您未通过任何方式侵犯我方的知识产权或其他合法权利。</u></b></p>
        <p>2.8 您不得将本产品及相关服务用于任何非法或侵权活动，包括但不限于利用产品及相关服务侵犯他人隐私权利、知识产权，将其用于展示、传播包含色情、种族主义、低级趣味、淫秽、诽谤中伤、污辱性质的资料，以及传播任何针对宗教、民族传统、人种、性别、年龄的各种仇恨、歧视、侵权和偏见的内容。</p>
        <p>2.9 如果您发现在本产品及相关服务中存在任何侵犯您权利的内容，您可以通过我方提供的联系方式与我方取得联系，并提供您有相关权利的证据，我方将会依据相关法律规定及时处理您的反馈。</p>
        <h2>3. 关于“账号”</h2>
        <p>3.1 本产品及相关服务为您提供了注册通道。您设置的帐号、密码是用以登录并以注册用户身份使用本产品及相关服务的凭证。</p>
        <h3>3.2 帐号注销</h3>
        <p><b>在需要终止使用帐号服务时，符合以下条件的，您可以申请注销您的帐号：</b></p>
        <p><b>（1）您仅能申请注销您本人的帐号，并依照我方的流程进行注销；</b></p>
        <p><b>（2）您仍应对您在注销帐号前使用本产品及相关服务的行为承担相应责任；</b></p>
        <p><b>（3）注销成功后，帐号记录、功能等将无法恢复或提供；</b></p>
        <p><b>（4）对于您的账号中尚存的全部权益（包括会员权益、余额等），您选择主动放弃，且不要求我方提供任何形式的补偿或赔偿。</b></p>
        <p><b>如您需要注销您的帐号，你可以通过官方渠道与我司取得联系要求注销您的账号，我方会在收到您的请求后<u>十五个工作日内</u>，完成注销或与您协商以确认账号注销事宜。</b></p>
        <p><b><u>3.3 您理解并承诺，您所设置的帐号不得违反国家法律、法规及的相关规则，您的帐号名称等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、头像等或采取其他足以让人引起混淆的方式）开设帐号，不得恶意注册帐号（包括但不限于频繁注册、批量注册帐号等行为）。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。我方有权对您提交的注册信息进行审核，但我方的审核行为不为我方设立任何义务。</u></b></p>
        <p><b><u>3.4 您注册的帐号仅限于您本人使用，未经我方书面同意，禁止以任何形式赠与、出借、出租、转让、售卖或以其他方式许可他人使用该帐号。如果我方发现或者有合理理由认为使用者并非帐号初始注册人，为保障帐号安全，我方有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。</u></b></p>
        <p>3.5 您有责任维护个人帐号、密码的安全性与保密性，并对您以注册帐号名义所从事的活动承担全部法律责任，包括但不限于您在本产品及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。您应高度重视对帐号与密码的保密，在任何情况下不向他人透露帐号及密码。若发现他人未经许可使用您的帐号或发生其他任何安全漏洞问题时，您应当立即通知我方。</p>
        <p>3.6 如您遗忘了账号信息或因为其他情况导致无法通过账号登录，可以通过产品及相关页面的引导或联系我方官方请求找回账号信息。<b><u>您理解并认可，账号找回机制仅识别申请找回人提供的信息与后台信息是否一致，而无法保证申请人是否系帐号真正有权使用者。我方特别提醒您应妥善保管您的账号信息。当您使用完毕后，应退出。因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您应自行承担相应责任。</u></b></p>

        <p>3.7 除自行注册帐号外，您也可选择通过授权使用您合法拥有的包括但不限于我方和 / 或其关联方的其他产品或平台用户帐号登录使用本产品及相关服务。</p>
        <p>3.8 您理解并同意，除您登录、使用本产品及相关服务外，您可能还可以用帐号登录使用我方及关联方或其他合作方提供的其他产品、服务。您以帐号登录并使用前述服务的，同样应受其他产品、服务实际提供方的用户协议及其他协议条款约束。您帐号的头像、昵称等公开信息可能会一并同步。</p>
        <p>3.9 当您完成的帐号注册、登录并进行合理和必要的身份验证后，您可以向我方要求查询、修正自己提交的个人身份信息。您理解并同意，出于安全性和身份识别（如帐号信息或密码找回服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。您也可以申请注销帐号，我方会在完成个人身份、安全状态、设备信息、侵权投诉等方面的合理和必要的验证后协助您注销帐号，并依照您的要求删除有关您帐号的一切信息，法律法规另有规定的除外。</p>

        <h2>4. 用户个人信息保护</h2>
        <p>我方与您一同致力于您个人信息（即能够独立或与其他信息结合后识别您身份的信息）的保护。保护用户个人信息是我方的基本原则之一，在使用本产品及相关服务的过程中，您可能会需要提供您的个人信息（包括但不限于您的姓名、电话号码、位置信息、设备信息等），以便我方向您提供更好的服务和相应的技术支持。我方将依法保护您浏览、修正、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化处理等其他与本产品及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。更多关于您个人信息保护的内容，请参看《隐私政策》，本协议与《隐私政策》有不符的，以《隐私政策》内容为准。</p>

        <h2>5. 用户行为规范</h2>
        <p>5.1 用户行为要求</p>
        <p>您应对您使用本产品及相关服务的行为负责，除非法律允许或者经我方事先书面许可，您使用本产品及相关服务不得具有下列行为：</p>
        <p>5.1.1 使用未经我方授权或许可的任何插件、外挂、系统或第三方工具对本产品及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
        <p>5.1.2 利用或针对本产品及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
        <p>（1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；</p>
        <p>（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</p>
        <p>（3）明知他人从事危害网络安全的活动的，为其提供技术支持等帮助；</p>
        <p>（4）使用未经许可的数据或进入未经许可的服务器/帐号；</p>
        <p>（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>
        <p>（6）未经许可，企图探查、扫描、测试系统或网络的弱点或其它实施破坏网络安全的行为；</p>
        <p>（7）企图干涉、破坏系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</p>
        <p>（8）对本产品及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本产品及相关服务的源代码；</p>
        <p>（9）违反法律法规、本协议、我方的相关规则及侵犯他人合法权益的其他行为。</p>
        <p><b><u>5.1.3 如果我方有理由认为您的行为违反或可能违反上述约定的，我方可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。请注意，这不代表我方保证能够及时处理您或其他用户所有的违约行为，也不为我方设立任何义务。</u></b></p>
        <p>5.2 信息内容展示及规范</p>
        <p>5.2.1 您按规定完成实名认证后，可以发布信息、互动交流、评论等。</p>
        <p><b><u>5.2.2 您制作、评论、发布、传播的信息应自觉遵守法律法规，保证该等信息不侵害国家、社会或其他任何第三人的合法权益，并保证其真实性，否则我方有权立即采取相应处理措施。您同意并承诺不制作、复制、发布、传播下列信息：</u></b></p>
        <p><b>（1）反对宪法确定的基本原则的；</b></p>
        <p><b>（2）危害国家安全，泄露国家秘密的；</b></p>
        <p><b>（3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</b></p>
        <p><b>（4）损害国家荣誉和利益的；</b></p>
        <p><b>（5）宣扬恐怖主义、极端主义的；</b></p>
        <p><b>（6）宣扬民族仇恨、民族歧视，破坏民族团结的；</b></p>
        <p><b>（7）煽动地域歧视、地域仇恨的；</b></p>
        <p><b>（8）破坏国家宗教政策，宣扬邪教和封建迷信的；</b></p>
        <p><b>（9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；</b></p>
        <p><b>（10）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</b></p>
        <p><b>（11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</b></p>
        <p><b>（12）侮辱或者诽谤他人，侵害他人合法权益的；</b></p>
        <p><b>（13）对他人进行暴力恐吓、威胁，实施人肉搜索的；</b></p>
        <p><b>（14）涉及他人隐私、个人信息或资料的；</b></p>
        <p><b>（15）散布污言秽语，损害社会公序良俗的；</b></p>
        <p><b>（16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；</b></p>
        <p><b>（17）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</b></p>
        <p><b>（18）侵害未成年人合法权益或者损害未成年人身心健康的；</b></p>
        <p><b>（19）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</b></p>
        <p><b>i. 任何暴力和/或自残行为内容；</b></p>
        <p><b>ii. 任何威胁生命健康、危及自身或他人人身及/或财产权利的内容；</b></p>
        <p><b>iii. 怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；</b></p>
        <p><b>（20）其他含有违反法律法规、政策及公序良俗、干扰正常运营或侵犯其他用户或第三方合法权益内容的信息。</b></p>
        <p><b><u>5.3 您可以通过软件及相关页面内的反馈渠道向我方投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，我方将及时受理和处理您的投诉举报。</u></b></p>

        <h2>6. 信息内容使用规范</h2>
        <p><b>未经我方书面许可，任何用户、第三方均不得自行或授权、允许、协助他人对本产品及相关服务中信息内容进行如下行为：</b></p>
        <p><b>（1）复制、读取、采用本产品及相关服务的信息内容，用于商业用途；</b></p>
        <p><b>（2）擅自编辑、整理、编排本产品及相关服务的信息内容后在本产品及相关服务的页面以外的渠道进行展示；</b></p>
        <p>（3）自行或协助第三人对本产品及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响；</p>
        <p>（4）其他非法获取或使用本产品及相关服务的信息内容的行为。</p>

        <h2>7. 违约处理</h2>
        <p><b><u>7.1 针对您违反本协议或其他服务条款的行为，我方有权独立判断并视情况采取预先警示、删除内容、限制帐号部分或者全部功能直至终止提供服务、永久关闭帐号等措施，对于因此而造成您无法正常使用帐号及相关服务、无法正常获取您帐号内资产或其他权益等后果，我方不承担任何责任。我方有权公告处理结果，且有权根据实际情况决定是否恢复相关帐号的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为，我方将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。对已删除内容我方有权不予恢复。</u></b></p>
        <p>7.2 因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的全部法律责任。因您的违法或违约等行为导致我方及其关联方、控制公司、继承公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿我方及其关联方、控制公司、继承公司因此遭受的全部损失。</p>
        <p>7.3 我方尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用本产品及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，我方有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担可能因此产生的全部法律责任；如因您的侵权行为导致我方及其关联方、控制公司、继承公司遭受损失的（包括但不限于经济、商誉等损失），您还应足额赔偿我方及其关联方、控制公司、继承公司遭受的全部损失。</p>
        <h2>8. 服务的变更、中断和终止</h2>
        <p>8.1 您理解并同意，我方提供的本产品及相关服务是按照现有技术和条件所能达到的现状提供的。我方会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，我方不能随时或始终预见和防范法律、技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本产品及相关服务以及其他的损失和风险。</p>

        <p>8.2 您理解并同意，我方为了整体服务运营、平台运营安全的需要，有权视具体情况决定服务/功能的设置及其范围修改、中断、中止或终止本产品及相关服务。</p>
        <h2>9. 广告</h2>
        <p>您理解并同意，我方可能会在产品及相关服务页面向您展示、推送具有相关性的信息、广告发布或品牌推广信息等，包括向您展示第三方的商业广告。对于第三方商业广告的真实性，我司无法提供保证，请你自行确认，并审慎理解该等广告信息。</p>
        <h2>10. 知识产权</h2>
        <p>10.1 我方在本产品及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于我方及其实际权利人所有。我方提供及相关服务时所依托的软件的著作权、专利权及其他知识产权均归我方及其实际权利人所有。未经我方极其实际权利人许可，任何人不得擅自使用（包括但不限于通过任何机器人、“蜘蛛”等程序或设备监视、复制、传播、展示、镜像、上载、下载）本产品及相关服务中的内容。</p>
        <p><b><u>10.2 您不得删除本产品及相关服务上的任何权利标识。</u></b></p>
        <p><b><u>10.3 您不得在未经过授权的情况下对于本产品及相关服务中包含的任何权利标识进行任何明示或暗示地使用。</u></b></p>
        <p><b><u>10.4 您应确保使用本产品及相关服务存储、传播的任何内容的合法性，确保内容不违反任何法律法规的规定，不违反公序良俗，版权清洁且您有权通过本产品及相关服务存储、传播，不侵犯任何第三方的知识产权或其他合法权益。任何与您存储、传播的内容有关的知识产权纠纷及其他纠纷将由您与相关方自行解决并承担全部责任，与易趣软件网站无关，易趣软件网站因此遭受任何损失的，您同意全额赔偿。</u></b></p>

        <h2>11. 免责声明</h2>

        <p><b><u>11.1 您理解并同意，本产品及相关服务可能会受多种因素的影响或干扰，我方不保证(包括但不限于)：</u></b></p>
        <p><b><u>11.1.1 本产品及相关服务完全适合用户的使用要求；</u></b></p>
        <p><b><u>11.1.2 本产品及相关服务不受干扰，及时、安全、可靠或不出现错误；用户经由我方取得的任何软件、服务或其他材料符合用户的期望；</u></b></p>
        <p><b><u>11.1.3 本产品及相关服务中任何错误都将能得到更正。</u></b></p>
        <p><b><u>11.2 针对您在使用我方产品及相关服务过程中所接触到的信息，请您谨慎对待并自行判断其真实性，对于您基于我方产品及相关服务上的信息所执行的行为给您造成的损失，我方不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。</u></b></p>
        <p>11.3 您理解并同意，在使用本产品及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于政府行为、自然灾害（如洪水、地震、台风等）、网络原因、战争、罢工、骚乱等。出现不可抗力情况时，我方将努力在第一时间及时修复，但因不可抗力造成的暂停、中止、终止服务或造成的任何损失，我方在法律法规允许范围内免于承担责任。</p>
        <p>11.4 我方依据本协议约定获得处理违法违规内容的权利，该权利不构成我方的义务或承诺，我方不能保证及时发现违法行为或进行相应处理。</p>
        <p><b><u>11.5 您理解并同意：我方仅以产品及相关服务当前的实际使用效果向你提供保证，关于本产品及相关服务，我方不提供任何种类的明示或暗示担保或条件，包括但不限于对于本产品及相关服务的有效性、使用效果等进行保证。您对本产品及相关服务的使用行为应自行承担相应风险。</u></b></p>
        <p>11.6 在任何情况下，我方均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用本产品及相关服务而遭受的利润损失，承担责任。除法律法规另有明确规定外，我方对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本产品及相关服务期间而支付给我方的费用（如有）。</p>

        <h2>12. 关于付费购买内容</h2>
        <p><b><u>12.1 本产品及相关服务部分内容您需要通过付费以获取，您可以自行选择是否进行付费。请您购买前仔细阅读具体付费内容的功能效果、服务内容、使用规则等，对于具体的付费内容有疑问的，请您在购买前及时咨询我方进行确认。针对部分付费功能存在单独的协议的，您应保证您在购买前已经仔细阅读、理解并同意对应协议的全部内容。</u></b></p>
        <p><b><u>12.2 如某项具体的服务、权益未标明使用期限、或未明使用期限为“永久”、“无限期”或“无限制”的，则这些服务的使用期限为自您开始使用该服务至该服务在软件停止提供之日为止。</u></b></p>

        <h2>13. 未成年人使用条款</h2>
        <p><b><u>13.1 若您是未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议后，方可使用本产品及相关服务。</u></b></p>
        <p>13.2 我方重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并应在取得监护人的同意以及在监护人指导下正确使用本产品及相关服务。</p>
        <p>13.3 未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。</p>

        <h2>14. 其他</h2>
        <p>14.1 本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。倘若本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款应在不违反法律的前提下按照尽可能接近本协议原条文目的之原则进行重新解释和适用，且本协议其它规定仍应具有完整的效力及效果。</p>

        <p>14.2 若您与我方发生任何争议，双方应尽量友好协商解决，协商不成，您同意应将争议提交至<u>易软信息科技（惠州）有限公司</u>所在地有管辖权的法院管辖。</p>
        <p>14.3 如果您对于本协议及其执行有任何疑问，请您及时与我方取得联系并进行确认。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.useragreement-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>

